// extracted by mini-css-extract-plugin
module.exports = {"text":"ConfigModal_text__237qa","offset":"ConfigModal_offset__2uuzW","modalContainer":"ConfigModal_modalContainer__aQH1J","modalHeader":"ConfigModal_modalHeader__17ElT"};